module.exports = __webpack_public_path__ + "img/Telegram.fe5ffe38.svg";